module.exports = __webpack_public_path__ + "img/resources-tutorials.604a03c5.png";